import { useTranslations } from '@/hooks';
import { DependentDropdownField } from './DependentDropdownField';

/**
 * Props:
 *   options   facility options from buildFacilityOptions
 *   clears    downstream field names to reset when the facility changes
 *   label     overrides the inbound "Received at" wording (outbounds says just "Facility name")
 *   disabled  locked once something downstream depends on it
 */
export const FacilityField = ({ options, clears, label, disabled = false }) => {
  const t = useTranslations();

  return (
    <DependentDropdownField
      name="facilityId"
      label={label ?? t('FORM_RECEIVED_AT_FACILITY')}
      placeholder={t('FORM_SELECT_FACILITY')}
      emptyMessage={t('COMMON_NO_OPTIONS')}
      options={options}
      clears={clears}
      disabled={disabled}
    />
  );
};
